// src/theme/Root.tsx
// Global root wrapper - adds cookie consent banner to every page.

import React from 'react';
import CookieConsent from 'react-cookie-consent';
import Link from '@docusaurus/Link';
import { translate } from '@docusaurus/Translate';
import { SITE_URLS } from '@site/src/urls';

export default function Root({ children }: { children: React.ReactNode }) {
  const acceptLabel = translate({ id: 'cookieConsent.accept', message: 'Accept' });
  const textPrefix = translate({
    id: 'cookieConsent.text',
    message:
      'We use cookies to enhance your experience on our website. By continuing to use this site, you agree to our',
  });
  const privacyLabel = translate({ id: 'cookieConsent.privacyPolicy', message: 'Privacy Policy' });

  return (
    <>
      {children}
      <CookieConsent
        location="bottom"
        buttonText={acceptLabel}
        cookieName="overblock-cookie-consent"
        style={{
          background: 'var(--color-card-background)',
          color: 'var(--color-text)',
          alignItems: 'center',
          padding: '1rem 1.5rem',
          zIndex: 9999,
          fontFamily: 'var(--ifm-font-family-base)',
          boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06)',
          border: '1px solid var(--color-separator)',
          borderBottom: 'none',
        }}
        buttonStyle={{
          background: 'var(--color-black-action)',
          color: 'var(--color-text-on-primary)',
          fontSize: '14px',
          padding: '0.5rem 1.5rem',
          borderRadius: '0.5rem',
          cursor: 'pointer',
          fontWeight: '500',
          border: 'none',
        }}
        expires={150}
      >
        {textPrefix}{' '}
        <Link
          to={SITE_URLS.POLICY}
          style={{ color: 'var(--ifm-link-color)', textDecoration: 'underline', fontWeight: '500' }}
        >
          {privacyLabel}
        </Link>
        .
      </CookieConsent>
    </>
  );
}
